const fr = {
  common: {
    loading: "Chargement...",
    please_wait: "Veuillez patienter",
    kent_project: "Un produit du Projet KenT"
  },
  nav: {
    home: "Accueil",
    gallery: "Galerie",
    guide: "Guide",
    create_frames: "Créer des cadres",
    how_to_use: "Comment utiliser",
    about: "À propos",
    contact: "Contact"
  },
  home: {
    welcome_to: "Bienvenue sur",
    subtitle: "Prenez vos photos en ligne avec des centaines de cadres tendance pour 2026. Sans application, sans filigrane et dans le respect de votre vie privée : prenez, puis partagez instantanément !",
    start_capture: "COMMENCER LA PRISE DE VUE",
    view_gallery: "VOIR LA GALERIE",
    follow_social: "Suivez KenT Photobooth sur Facebook et TikTok",
    social_popup_title: "Suivez-nous !",
    social_popup_desc: "Rejoignez KenT Photobooth sur Facebook et TikTok pour obtenir les dernières mises à jour et de nouveaux cadres.",
    explore_now: "Explorer maintenant",
    memory_corner: "Coin Souvenirs",
    how_to_shoot: "Comment prendre des photos en photomaton ?",
    card1_title: "Choisir un cadre",
    card1_desc: "Sélectionnez un cadre, cliquez sur 'Continuer' et commencez à photographier !",
    card2_title: "Prendre des photos",
    card2_desc: "Après la prise de vue, cliquez sur continuer pour aller à la page suivante. Si vous souhaitez reprendre une seule photo, cliquez dessus et appuyez sur reprendre.",
    card3_title: "Choisir le cadre et télécharger",
    card3_desc: "Choisissez une couleur ou un cadre pour la photo, cliquez sur 'Télécharger' pour partager.",
    feature_title: "Photomaton professionnel à domicile entièrement gratuit",
    feature_sub1: "Expérience fluide",
    feature_sub2: "Aucune inscription requise",
    feature_sub3: "Pas de publicité",
    feature_sub4: "Pas de filigrane",
    feature_layout_title: "Multiples mises en page et cadres",
    feature_layout_desc: "Soyez créatif avec une grande variété de mises en page et de cadres, du classique au moderne, rendant vos photos plus uniques que jamais.",
    feature_filter_title: "Magnifiques filtres photomaton",
    feature_filter_desc: "Filtres de couleur spécialement ajustés pour le style photomaton, rendant la peau éclatante et les couleurs cristallines.",
    feature_share_title: "Partagez avec tout le monde en un clic",
    feature_share_desc: "Téléchargez facilement ou partagez rapidement via QR code, propagez la joie avec vos amis et votre famille en un instant.",
    shoot_now: "Photographier maintenant"
  },
  gallery: {
    title: "Galerie",
    heading: "Vos Moments 💙",
    photo_count: "photos",
    secure: "100% Sécurisé",
    free: "Gratuit",
    send_photo: "Envoyez-nous vos photos !",
    description: "Les photos les plus authentiques envoyées par les utilisateurs — chacune est un souvenir inoubliable. Sauf pour la fonctionnalité de partage par QR code, le site ne stockera aucune de vos photos, soyez rassurés à 100% ! Vous pouvez choisir de nous l'envoyer lors du téléchargement ou en cliquant sur le bouton à côté !",
    loading_more: "Chargement de plus...",
    no_photos: "Aucune photo pour l'instant"
  },
  guide_create: {
    title: "Guide de création de cadres",
    subtitle: "Comment créer des cadres avec Canva",
    desc1: "Nous avons préparé des cadres de base pour libérer votre créativité ! 🎨",
    desc2: "Les cadres que vous créez peuvent être utilisés avec la fonctionnalité de cadre personnalisé !",
    step1_title: "Choisir un modèle de cadre Canva",
    template4: "Modèle 4 photos (1x4)",
    template4_desc: "Pour une mise en page verticale de 4 photos.",
    template6: "Modèle 6 photos (2x3)",
    template6_desc: "Pour une mise en page de 6 photos.",
    template2: "Modèle 2 photos (2x2)",
    template2_desc: "Pour une mise en page de 2 photos.",
    step2_note_title: "Note importante :",
    step2_note_desc: "Gardez la zone colorée dans le petit cadre (gris, bleu, ou le carré destiné à accueillir la photo) au milieu comme arrière-plan pour la suppression.",
    step2_tip: "💡 Vous pouvez télécharger le cadre avec uniquement l'arrière-plan, supprimer l'arrière-plan, puis le remettre sur Canva pour ajouter des stickers (pour éviter une suppression désordonnée sur des stickers très complexes)",
    step3_title: "Télécharger l'image",
    step3_desc: "Après la conception, téléchargez le nouveau cadre créé sur votre appareil pour vous préparer à l'utiliser !",
    step4_title: "Supprimer l'arrière-plan avec Photopea",
    step4_desc: "🖼️ Guide pour supprimer l'arrière-plan sur Photopea",
    step4_li1: "Aller sur Photopea.com",
    step4_li2: "Faites glisser le fichier image ou utilisez 'Ctrl + O' pour ouvrir l'image téléchargée depuis Canva.",
    step4_li3: "Sélectionnez l'outil Baguette magique.",
    step4_li4: "Cliquez sur la zone colorée au milieu pour la sélectionner.",
    step4_li5: "Appuyez sur la touche Suppr de votre clavier.",
    step4_li6: "Allez dans Fichier > Exporter en > PNG. Cliquez sur Enregistrer.",
    step5_title: "Finalisation & Communauté",
    step5_desc1: "✨ Vous avez maintenant un fichier PNG transparent ! Retournez sur le site, cliquez sur le bouton \"Télécharger un cadre personnalisé\" sur la page de sélection des cadres et téléchargez-le pour un usage privé.",
    step5_desc2: "🔒 Le site ne stocke aucune image, vous pouvez donc l'utiliser en toute tranquillité !!!",
    step5_community: "Construisons la communauté ensemble",
    step5_community_desc1: "Si vous avez créé un cadre vraiment beau et satisfaisant, et que vous souhaitez le partager pour que tout le monde l'utilise sur ce site, n'hésitez pas à nous envoyer votre fichier PNG via Instagram.",
    step5_community_desc2: "💜 Votre contribution enrichira notre galerie de cadres. Merci beaucoup ! ❤️"
  },
  guide_use: {
    title: "Comment utiliser",
    subtitle: "En seulement 5 étapes simples, vous pouvez créer des photos de photomaton uniques et garder des souvenirs avec vos amis !",
    step: "Étape",
    step1_title: "Commencez votre aventure",
    step1_desc: "Sur la page d'accueil, cliquez sur le bouton \"Commencer la prise de vue\". N'oubliez pas d'accorder l'accès à la caméra à votre navigateur ! (Toutes les images sont traitées localement sur votre appareil pour une confidentialité maximale).",
    step2_title: "Choisir une mise en page",
    step2_desc: "Parcourez et sélectionnez la mise en page photo que vous préférez. De nombreuses mises en page adorables vous attendent.",
    step3_title: "Posez & Photographiez",
    step3_desc: "Choisissez librement des filtres de couleur ou des effets adaptés. Ajustez l'angle de votre caméra, prenez vos meilleures poses, et commencez à photographier ! Après avoir capturé toutes les photos, cliquez sur \"Continuer\".",
    step4_title: "Décorez votre cadre",
    step4_desc: "Faites ressortir votre photo en choisissant une couleur d'arrière-plan qui correspond à votre style, ou sélectionnez directement des cadres accrocheurs disponibles dans notre galerie.",
    step5_title: "Enregistrer & Partager",
    step5_desc: "Votre chef-d'œuvre est prêt ! Vous pouvez immédiatement télécharger l'image haute qualité sur votre appareil, ou utiliser la fonctionnalité \"Partager QR\" pour l'envoyer rapidement à vos amis à scanner et télécharger.",
    ready: "Êtes-vous prêt ?",
    create_frame_btn: "Créer votre propre cadre",
    start_btn: "Commencer la prise de vue maintenant",
    faq_title: "Foire Aux Questions",
    q1: "Qu'est-ce que KenT Photobooth ?",
    a1: "KenT Photobooth est une application web qui vous permet de prendre des photos de style photobooth directement dans votre navigateur sur ordinateur ou téléphone, sans installer de logiciel.",
    q2: "Le site stocke-t-il mes photos ?",
    a2: "Pas du tout. Tout le traitement des photos se fait directement dans votre navigateur (côté client). Les photos ne sont stockées temporairement sur le serveur que lorsque vous choisissez activement la fonction 'Partager QR' pour télécharger des photos sur votre téléphone.",
    q3: "Le partage par QR est-il sûr ?",
    a3: "Très sûr. Les liens de partage expirent automatiquement et toutes les données sur le serveur sont effacées après 1 semaine. Personne ne peut voir vos photos sans votre lien spécifique ou code QR.",
    q4: "Puis-je utiliser mes propres cadres ?",
    a4: "Oui ! Vous pouvez visiter la section 'Créer un cadre' pour voir les instructions sur la création de vos propres cadres avec Canva et Photopea, puis les télécharger pour un usage privé.",
    q5: "Le site est-il gratuit ?",
    a5: "Le site est 100 % gratuit. Vous pouvez me soutenir (Faire un don) en cliquant sur la section 'Contact' pour m'aider à maintenir le serveur !",
    steps_title: "Étapes d'exécution",
    still_need_help: "Encore besoin d'aide ?",
    help_desc: "Si vous rencontrez des problèmes lors de l'utilisation ou si vous souhaitez suggérer des idées, n'hésitez pas à nous envoyer un message !",
    contact_now: "Contactez-nous maintenant"
  },
  contact: {
    donate_title: "☕ Offrez-moi un café !",
    donate_desc: "Aidez-moi à rester motivé pour maintenir le serveur et développer de nouvelles fonctionnalités ! 💕",
    admin_badge: "Admin",
    contact_info: "Informations de contact",
    contact_desc: "J'ai codé ce site de photomaton comme cadeau pour ma chère mhoa 🥰💕",
    fb_page1: "Page Facebook",
    fb_page2: "Page Facebook"
  },
  about: {
    welcome: "Bienvenue sur KenT PhotoBooth",
    title1: "Capturez les moments",
    title2: "À votre façon",
    desc: "Nous offrons une expérience de photomaton professionnel directement dans votre navigateur. Rapide, privé et entièrement gratuit.",
    team_title: "Équipe de développement",
    author_title: "Auteur : Que Minh Thanh (Dev 2k8)",
    author_desc: "Celui qui a posé les bases et construit l'ensemble du système KenT PhotoBooth. Avec une passion pour la technologie et la créativité, KenT Software a réalisé l'idée d'un photomaton en ligne pratique pour tous.",
    designer_title: "Designers de cadres : Que Minh Thanh, Que Mai Huong",
    designer_desc: "L'équipe derrière les modèles de cadres brillants et diversifiés. Minutieux dans chaque détail pour s'assurer que chacune de vos photos devient spéciale et porte votre marque personnelle.",
    journey_title: "Parcours de développement",
    m1_title: "Début du projet",
    m1_desc: "Poser les premières pierres de l'idée d'un photomaton numérique. Le projet a démarré avec le désir d'apporter de la joie à travers chaque cadre.",
    m2_title: "Première version finale",
    m2_desc: "Après près de 2 mois de développement intensif, la première version complète est officiellement née, marquant une étape importante dans le parcours créatif.",
    m3_title: "Mise en ligne publique",
    m3_desc: "Lancement officiel du projet en ligne. Initialement construit en HTML, CSS et JS purs, fonctionnant activement pendant les 3 premières semaines.",
    m4_title: "Restructuration & React",
    m4_desc: "Un tournant majeur lorsque tout le code source a été converti vers la plateforme React moderne. En même temps, création de Facebook KenT Photobooth pour connecter les utilisateurs.",
    m5_title: "Relancement officiel",
    m5_desc: "Retour officiel avec un nouveau look, des performances exceptionnelles et un fonctionnement stable jusqu'à aujourd'hui.",
    features_title1: "Sécurité Maximale",
    features_desc1: "Les images sont traitées directement dans votre navigateur. Nous ne stockons jamais d'images personnelles sur nos serveurs.",
    features_title2: "Bibliothèque de Cadres Massive",
    features_desc2: "Constamment mis à jour avec les dernières tendances : Y2K, Aesthetic, Vintage, et plus encore.",
    features_title3: "Complètement Gratuit",
    features_desc3: "Profitez de toutes les fonctionnalités premium sans aucun coût. Votre joie est notre motivation.",
    features_title4: "Partage instantané",
    features_desc4: "Créez des codes QR et partagez des photos avec vos amis en quelques secondes. Pratique et ultra rapide.",
    features_title5: "Expérience fluide",
    features_desc5: "Interface optimisée, fonctionne sans problème sur tous les appareils, du mobile à l'ordinateur.",
    features_title6: "Qualité cristalline",
    features_desc6: "Les photos sont exportées en haute résolution, garantissant que chaque détail de vos souvenirs reste vibrant et net.",
    cta_title: "Prêt pour de belles photos ?",
    cta_desc: "Rejoignez la communauté d'utilisateurs de KenT PhotoBooth et commencez à créer aujourd'hui.",
    cta_btn: "Commencer à prendre des photos",
    users: "1000+ Utilisateurs"
  },
  photo_layout: {
    title: "Choisissez votre mise en page préférée !",
    subtitle: "Nous ajouterons plus de cadres à l'avenir. 🌸",
    photos: "photos",
    start_btn: "Commencer la prise de vue",
    alert_select: "Veuillez sélectionner une mise en page avant de continuer.",
    layout_prefix: "Mise en page",
  },
  take_photo: {
    record_video_btn: "Filmer",
    settings_btn: "Réglages",
    layout_label: "Mise en page :",
    reselect_layout: "Resélectionner la mise en page",
    confirm_reselect: "Êtes-vous sûr de vouloir resélectionner la mise en page ? Les photos capturées seront perdues.",
    upload_photos: "Télécharger des photos",
    camera: "Caméra",
    confirm_upload: "Êtes-vous sûr de vouloir passer en mode téléchargement ? Les photos capturées seront perdues.",
    confirm_exit_video_mode: "Voulez-vous changer de mode avant d'avoir terminé la capture ? Les photos actuelles seront perdues.",
    flash_toggle: "Activer/désactiver l'effet flash",
    flip_camera: "Retourner la caméra (miroir)",
    alert_camera_off: "Veuillez d'abord activer la caméra !",
    confirm_retake: "Êtes-vous sûr de vouloir reprendre la photo #",
    confirm_change: "Voulez-vous changer cette photo ?",
    alert_need_photos: "Il faut {requiredPhotos} photos pour continuer !",
    filter_normal: "Normal",
    filter_gray: "Gris",
    filter_sepia: "Sépia",
    filter_bright: "Lumineux",
    filter_contrast: "Net",
    filter_blur: "Flou",
    slot: "Emplacement",
    support_off: "Support désactivé",
    support_on: "Support de prise de vue",
    capturing: "Capture en cours...",
    processing: "Traitement...",
    processing_subtitle: "Vos photos sont en cours de traitement...",
    manual_capture: "Manuel",
    retake_photo_btn: "Reprendre la photo #",
    auto_capture: "Auto",
    continue_btn: "Continuer",
    confirm_retake_all: "Êtes-vous sûr de vouloir tout reprendre ? Les photos capturées seront perdues.",
    retake_all_btn: "Tout reprendre",
    countdown_label: "⏱️ Compte à rebours :",
    seconds: "sec",
    filter_title: "Filtres",
    effect_title: "Effets",
    effect_notice: "(Visible après la capture)",
    settings_title: "Paramètres de la caméra",
    select_camera: "Sélectionner la caméra :",
    camera_label: "Caméra",
    switch_camera_tip: "Basculer entre caméra avant/arrière",
    mirror_label: "Miroir de la caméra",
    sound_label: "Activer le son de capture",
    flash_screen_label: "Activer l'effet flash",
    live_gif_label: "Enregistrer une vidéo avec photos (5s)",
    close_btn: "Fermer",
    edit_title: "Modifier la photo",
    cancel_btn: "Annuler",
    apply_btn: "Appliquer",
    crop_tip: "Recadrez avec soin !!!",
    support_modal_title: "Sélectionner le cadre de support",
    support_modal_desc: "Cadre virtuel sur la caméra pour l'alignement. Le vrai cadre sera choisi à la fin.",
    search_placeholder: "Rechercher des cadres...",
    clear_support_btn: "Désactiver le cadre de support actuel"
  },
  result: {
    thanks: "Merci d'utiliser notre application web !",
    confirm_retake: "Voulez-vous reprendre ?",
    upload_success: "Merci d'avoir partagé votre photo !",
    upload_error: "Erreur lors du téléchargement de la photo.",
    no_image_to_share: "Aucune image trouvée à partager.",
    error_load_frame: "Impossible de charger le cadre personnalisé !",
    error_load_img: "Impossible de charger le cadre :",
    error_invalid_file: "Fichier invalide ! Veuillez sélectionner une image PNG.",
    cancel_btn: "Annuler",
    photo_num: "Photo",
    scroll_tip: "Faites défiler vers le bas pour décorer votre cadre photo",
    bg_color: "Arrière-plan",
    photo_mode: "Mode photo",
    photo_frame: "Cadre photo",
    use_custom_frame: "Cadre personnalisé",
    search_frame_placeholder: "Rechercher des cadres...",
    complete_btn: "Terminer",
    retake_btn: "Reprendre",
    contribute_title: "Contribuer à la bibliothèque",
    contribute_question: "Souhaitez-vous partager votre photo avec notre galerie ?",
    frame_upload_success: "Cadre personnalisé téléchargé avec succès !",
    qr_success: "QR code créé !",
    qr_error: "Impossible de créer le QR. Veuillez réessayer.",
    zoom_photo: "Agrandir la photo",
    share_qr_label: "Partager QR",
    creating_qr: "Création...",
    create_qr_btn: "Créer QR",
    share_your_photo: "Partagez votre photo",
    share_via_qr: "Partager via QR",
    generate_qr: "Générer QR",
    select_download_title: "Sélectionner les photos à télécharger",
    download_photo_title: "Télécharger la photo",
    save_all: "Enregistrer le strip",
    save_one: "Enregistrer une photo",
    download_btn: "Télécharger",
    video_processing: "Traitement en cours...",
    download_video_btn: "Télécharger la vidéo",
    close_btn: "Fermer",
    your_photo_title: "Votre photo",
    loading_photo: "Chargement de la photo...",
    one_photo: "1 photo",
    two_photos: "2 photos",
    custom_frame_title: "Télécharger un cadre personnalisé",
    frame_uploaded: "Cadre téléchargé",
    drag_drop_tip: "Faites glisser & déposer l'image ici",
    or_click_tip: "ou cliquez pour sélectionner un fichier",
    yes_create_qr: "Oui & Créer QR",
    no_continue_qr: "Non, juste créer QR",
    generating_qr: "Génération du QR Code",
    generating_qr_desc: "Nous générons un QR code pour que vous puissiez partager votre photo, veuillez patienter un instant !",
    your_qr_title: "Votre QR Code",
    scan_qr_tip: "Scannez le QR code avec la caméra de votre téléphone pour télécharger la photo !",
    or_copy_link: "Ou copiez le lien :",
    copied_link: "Lien copié !",
    storage_notice: "Note : Cette photo existe pendant 1 semaine. Après cela, elle sera automatiquement supprimée !",
    storage_note_title: "Note",
    storage_note_part1: "Cette photo existe pendant",
    storage_note_duration: "1 semaine",
    storage_note_part2: ". Après cela, elle sera automatiquement supprimée !",
    thanks_title: "Merci !",
    share_invite: "Veuillez partager avec tout le monde !",
    frame_update_notice: "De nouveaux cadres seront mis à jour constamment ^^",
    contribute_question_alt: "Souhaitez-vous contribuer cette photo à la collection publique ?",
    yes_contribute: "Oui, contribuer",
    no_thanks: "Non, merci",
    contribute_success: "Contribution réussie !",
  },
  share_view: {
    not_found: "La photo n'existe pas ou a expiré",
    load_error: "Impossible de charger la photo. Veuillez réessayer.",
    loading_title: "Chargement de la photo...",
    loading_sub: "Récupération de la photo depuis le serveur",
    error_title: "Photo introuvable",
    home_btn: "Retour à l'accueil",
    header_title: "Partager la photo",
    header_sub: "Partagé depuis KenT Photobooth",
    one_photo: "1 photo",
    two_photos: "2 photos",
    tooltip_not_ready: "Version 2 photos pas encore prête",
    tooltip_ready: "Afficher 2 photos",
    tag_layout: "Mise en page :",
    tag_frame: "Avec cadre",
    tag_valid: "Valide 1 semaine",
    download_title: "Télécharger",
    downloading: "Téléchargement...",
    download_btn: "Télécharger maintenant",
    cta_text: "Voulez-vous créer votre propre photomaton ?",
    cta_btn: "Créez le vôtre",
    notice: "Avis :",
    notice_server: "Cette photo n'est disponible que pendant 1 semaine et sera automatiquement supprimée.",
    notice_local: "Ce lien ne fonctionne que lorsque le partageur est sur le site. Veuillez télécharger maintenant !",
    tip: "Astuce : Enregistrez la photo pour garder vos beaux souvenirs !",
    created_by: "Créé par",
    preparing: "Préparation de la photo...",
    preparing_sub: "Optimisation au format PNG pour vous.",
    select_download_title: "Sélectionner les photos à télécharger",
    photo_num: "Photo",
    cancel_btn: "Annuler",
    download_btn: "Télécharger",
    custom_frame_title: "Télécharger un cadre personnalisé",
    frame_uploaded: "Cadre téléchargé",
    drag_drop_tip: "Faites glisser & déposer l'image ici",
    or_click_tip: "ou cliquez pour sélectionner un fichier",
    contribute_title: "Contribuer à la galerie",
    contribute_question: "Souhaitez-vous partager votre photo avec notre galerie ?",
    yes_create_qr: "Oui & Créer QR",
    no_continue_qr: "Non, juste créer QR",
    generating_qr: "Génération du QR Code",
    generating_qr_desc: "Nous générons un QR code pour que vous puissiez partager votre photo, veuillez patienter un instant !",
    your_qr_title: "Votre QR Code",
    scan_qr_tip: "Scannez le QR code avec la caméra de votre téléphone pour télécharger la photo !",
    or_copy_link: "Ou copiez le lien :",
    copied_link: "Lien copié !",
    storage_notice: "Note : Cette photo existe pendant 1 semaine. Après cela, elle sera automatiquement supprimée !",
    close_btn: "Fermer",
    thanks_title: "Merci !",
    share_invite: "Veuillez partager avec tout le monde !",
    frame_update_notice: "De nouveaux cadres seront mis à jour constamment ^^",
    contribute_question_alt: "Souhaitez-vous contribuer cette photo à la collection publique ?",
    yes_contribute: "Oui, contribuer",
    no_thanks: "Non, merci",
    contribute_success: "Contribution réussie !",
    your_photo_title: "Votre photo",
    loading_photo: "Chargement de la photo...",
    one_photo: "1 photo",
    two_photos: "2 photos",
    download_photo_title: "Télécharger la photo",
    save_all: "Enregistrer le strip",
    save_one: "Enregistrer une photo",
    creating_qr: "Création...",
    create_qr_btn: "Créer QR",
    share_your_photo: "Partagez votre photo",
    share_via_qr: "Partager via QR"
  },
  welcome_modal: {
    title: "Bienvenue !",
    timer_title: "Choisir le minuteur",
    timer_body: "Vous pouvez choisir le délai de compte à rebours pour chaque prise de vue !",
    session_title: "Prises consécutives",
    session_body: "Cette session prendra plusieurs photos consécutivement — prenez vos meilleures poses ! 🌟",
    privacy_title: "Note de confidentialité",
    privacy_body: "Sauf si vous utilisez la fonction de partage, le site ne stockera aucune de vos photos.",
    start_btn: "COMMENCER"
  },
  footer: {
    description: "Photobooth est un endroit pour préserver des moments mémorables avec une haute qualité d'image, une interface conviviale et de nombreux effets créatifs pour tous les âges.",
    contact: "Contact",
    total_visits: "Visites totales :"
  }
};

export default fr;
